import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=5b4fef6d&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=javascript&"
export * from "./Edit.vue?vue&type=script&lang=javascript&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=5b4fef6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4fef6d",
  null
  
)

export default component.exports